// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const CompareArrows: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 42 30" enableBackground="new 0 0 42 30" xmlSpace="preserve">
<g>
	<polygon points="14.77,19.17 0.17,19.17 0.17,23.33 14.77,23.33 14.77,29.58 23.08,21.25 14.77,12.92 	"/>
	<polygon points="27.23,6.67 27.23,0.42 18.92,8.75 27.23,17.08 27.23,10.83 41.83,10.83 41.83,6.67 	"/>
</g>
</svg>;
};

export default React.memo(CompareArrows);
